import CodeMirror, { EditorView } from '@uiw/react-codemirror';
import { markdown } from '@codemirror/lang-markdown';

export interface EditorSelection {
  from: number;
  to: number;
  text: string;
}

/**
 * Editor de Markdown (CodeMirror 6). MD limpo (bom pros agentes), seleção precisa
 * (pro fluxo de edição por IA) e quebra de linha. onSelection reporta o trecho
 * selecionado — usado pela edição assistida ("muda este parágrafo").
 */
export function CodeEditor({
  value,
  onChange,
  onSelection,
  readOnly = false,
  height = '60vh',
}: {
  value: string;
  onChange: (v: string) => void;
  onSelection?: (sel: EditorSelection) => void;
  readOnly?: boolean;
  height?: string;
}) {
  return (
    <CodeMirror
      value={value}
      height={height}
      theme="dark"
      readOnly={readOnly}
      extensions={[markdown(), EditorView.lineWrapping]}
      onChange={onChange}
      onUpdate={(vu) => {
        if (!onSelection || !vu.selectionSet) return;
        const r = vu.state.selection.main;
        onSelection({ from: r.from, to: r.to, text: vu.state.sliceDoc(r.from, r.to) });
      }}
      basicSetup={{ lineNumbers: true, foldGutter: false, highlightActiveLine: !readOnly, autocompletion: false }}
    />
  );
}
